import React, {useState} from "react";
import {useTranslation} from "react-i18next";
// local
import {Modal} from "components/Modal";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {Info} from "components/Info";
import {color} from "constants/color.consts";
import {
  IconHandOnRight,
  IconUsers,
  IconMailLetter,
  IconSheet,
  IconCopy,
} from "components/icons";
import {LockValue} from "components/LockValue";
import {hasPermission} from "helpers/helper";
import {Preloader} from "components/Preloader";

export const CopyProcurementPlanModal = ({
  fromProjectName,
  onCancel,
  onConfirm,
  loading,
}) => {
  const {t} = useTranslation();
  const canCopyWithRecipients = hasPermission(["CREATE_RFT_BY_COPY_WITH_RECIPIENTS"]);
  const [addSameSuppliers, setAddSameSuppliers] = useState(canCopyWithRecipients && true);
  const [selectSamePeople, setSelectSamePeople] = useState(canCopyWithRecipients && true);
  const [includeInvitedByEmail, setIncludeInvitedByEmail] = useState(
    canCopyWithRecipients && true
  );

  const onToggleAddSameSuppliers = (value) => {
    setAddSameSuppliers(value);
    if (!value) {
      setSelectSamePeople(false);
    }
  };

  const handleConfirm = () =>
    onConfirm({
      addSameSuppliers,
      selectSamePeople,
      includeInvitedByEmail,
    });

  return (
    <Modal
      boldTitle
      titleIcon={<IconSheet addClass="mr-2" />}
      titleText={t("COPY_PROCUREMENT_PLAN_TITLE")}
      rounded
      placeBitLow
      style={{marginTop: "15vh"}}
      width="526"
      onClose={!loading && onCancel}
      disabledCloseButton={loading}
    >
      <div className="procurement-create-edit-modal__content">
        <div className="mb-6 fz-16">
          {t("COPY_PROCUREMENT_PLAN_DESCRIPTION")} {fromProjectName}
        </div>

        <div className="mb-4 copy-procurement-option-item">
          <LockValue
            canPermissions={["CREATE_RFT_BY_COPY_WITH_RECIPIENTS"]}
            needLabel
            needShowModalToSubscribe
            addClassWrapper="mb-4"
          >
            <div className="df-row-center">
              <CustomRadioSwitch
                checked={addSameSuppliers}
                isActive={onToggleAddSameSuppliers}
                isDisabledLabel={!canCopyWithRecipients}
                small
                disabled={!canCopyWithRecipients}
                prefixLabelContent={
                  <IconHandOnRight color={color.green} addClass="ml-3 mr-2" />
                }
                label={t("ADD_SAME_SUPPLIERS_LABEL")}
              />
            </div>
          </LockValue>
          <Info tooltip="COPY_PLAN_INFO_ADD_SUPPLIERS" centerText />
        </div>

        <div className="mb-4 copy-procurement-option-item">
          <LockValue
            canPermissions={["CREATE_RFT_BY_COPY_WITH_RECIPIENTS"]}
            needLabel
            needShowModalToSubscribe
            addClassWrapper="mb-4"
          >
            <div className="df-row-center">
              <CustomRadioSwitch
                checked={selectSamePeople}
                small
                isActive={(value) => {
                  setSelectSamePeople(value);
                }}
                disabled={!canCopyWithRecipients || !addSameSuppliers}
                isDisabledLabel={!canCopyWithRecipients}
                prefixLabelContent={
                  <IconUsers color={color.orange} addClass="ml-3 mr-2" />
                }
                label={t("SELECT_SAME_PEOPLE_LABEL")}
              />
            </div>
          </LockValue>
          <Info tooltip="COPY_PLAN_INFO_SELECT_PEOPLE" centerText />
        </div>

        <div className="mb-8 copy-procurement-option-item">
          <LockValue
            canPermissions={["CREATE_RFT_BY_COPY_WITH_RECIPIENTS"]}
            needLabel
            needShowModalToSubscribe
          >
            <div className="df-row-center">
              <CustomRadioSwitch
                checked={includeInvitedByEmail}
                small
                isDisabledLabel={!canCopyWithRecipients}
                isActive={(value) => {
                  setIncludeInvitedByEmail(value);
                }}
                disabled={!canCopyWithRecipients}
                prefixLabelContent={
                  <IconMailLetter color={color.purple} addClass="ml-3 mr-2" />
                }
                label={t("INCLUDE_EMAIL_INVITES_LABEL")}
              />
            </div>
          </LockValue>
          <Info tooltip="COPY_PLAN_INFO_INCLUDE_EMAIL_INVITES" centerText />
        </div>

        <div className="df-row-jce-center mt-8">
          <ButtonTransparent
            name="CANCEL"
            color="red"
            onClick={onCancel}
            addClass="mr-4"
            disabled={loading}
          />
          <ButtonTransparent
            name="COPY_NOW"
            disabled={loading}
            nonTransparent
            icon={
              loading ? (
                <Preloader size="small" />
              ) : (
                <IconCopy color={color.white} addClass="mr-2" />
              )
            }
            onClick={handleConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};
